import { render, staticRenderFns } from "./PublishingStatementsTopSlot.vue?vue&type=template&id=42cd74ec"
import script from "./PublishingStatementsTopSlot.vue?vue&type=script&lang=js"
export * from "./PublishingStatementsTopSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports